import(/* webpackMode: "eager" */ "/vercel/path0/frontend/lesson-platform/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["ClientProviders"] */ "/vercel/path0/frontend/lesson-platform/src/app/client-providers.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend/lesson-platform/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend/lesson-platform/node_modules/katex/dist/katex.min.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/lesson-platform/src/components/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend/lesson-platform/src/styles/katex.css");
